import {
  Activity, LayoutDashboard, LifeBuoy, LineChart, ListChecks, MessagesSquare,
  PieChart, ScrollText, Settings, Users, Wallet,
} from 'lucide-react';

/* The console's sections, in sidebar order. `id` is the URL segment:
   /admin/<id>. */
export const NAV = [
  {
    group: 'Business',
    items: [
      { id: 'overview', label: 'Overview', icon: LayoutDashboard, description: 'The business at a glance' },
      { id: 'revenue', label: 'Revenue', icon: Wallet, description: 'Payments from Stripe, Google Play and the App Store' },
      { id: 'kpis', label: 'KPIs', icon: LineChart, description: 'Installs, onboarding, retention and engagement' },
      { id: 'gestures', label: 'Gestures', icon: Activity, description: 'How people use their daily gestures' },
    ],
  },
  {
    group: 'People',
    items: [
      { id: 'customers', label: 'Customers', icon: Users, description: 'Every account, with plan, role and profile' },
      { id: 'segments', label: 'Segments', icon: PieChart, description: 'Who your customers are, from onboarding answers' },
      { id: 'support', label: 'Support', icon: LifeBuoy, description: 'Support tickets' },
    ],
  },
  {
    group: 'Growth',
    items: [
      { id: 'reddit', label: 'Reddit', icon: MessagesSquare, description: 'Story drafts and leads from Reddit' },
      { id: 'unasked', label: 'Unasked waitlist', icon: ListChecks, description: 'Signups for Unasked, the app for her' },
    ],
  },
  {
    group: 'System',
    items: [
      { id: 'settings', label: 'Settings', icon: Settings, description: 'Feature flags and maintenance jobs' },
      { id: 'logs', label: 'Device logs', icon: ScrollText, description: 'The app log stored on this device' },
    ],
  },
];

export const SECTIONS = NAV.flatMap((g) => g.items);
export const SECTION_IDS = new Set(SECTIONS.map((s) => s.id));

/* Old tab names, the retired /admin/tickets page, and the retired Better
   Husband waitlist (the website now always shows the store badges). */
export const SECTION_ALIASES = {
  tickets: 'support',
  waitlist: 'unasked',
  clusters: 'segments',
  metrics: 'gestures',
  kpi: 'kpis',
  charts: 'revenue',
};

export const sectionById = (id) => SECTIONS.find((s) => s.id === id);
